import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({
  name: z.string(),
})

export type FormValues = z.infer<typeof schema>

export const resolver = zodResolver(schema)

export const FORM_ID = 'invite-user-form'
